<template>
<div v-if="ready" id="grid-layout" style="background: #ffffff; overflow-y: auto;">
  <div id="row-container" style="display: table; height: 100%; margin: auto; width: 100%">
    <div style="display: table-cell; vertical-align: middle; height: 100%;">
      <div class="row" style="margin: 0px;">
        <div v-for="(iter,index) in iterable" :class="classes[index]">
          <div :id="'thumb-'+index" class="thumbnail" style="margin: 10px 0px;">
            <a href="" @click.prevent="iter.typ == 'Articoli di stampa' ? loadDoc(iter) : activeData.father.pvi ? '' : $root.navigateTo(iter.sid, iter.fid)">

              <!--immagine-->
              <div @click.prevent="activeData.father.pvi ? openImage(iter, index, $event) : ''" class="embed-responsive embed-responsive-4by3 bg-cover" 
              :style="{'width': '100%', 'background-image': 'url('+ anteprima(iter) + ')'}"></div>

              <!--info prodotto-->
                <!--c'è il popup acquisto-->
              <div v-if="activeData.father.pvi" class="caption">
                <!--mostro maggiori informazioni sul prodotto-->
                <div v-if="$Behaviors.showInfoOnGridBox">
                  <div class="cod-label" style="font-size: smaller;">{{iter.sid}} - {{$Jed.firstUpperTranslate('qty')}}: {{iter.qty}}</div>
                  <div class="cod-label" style="font-size: smaller;">{{iter.des}}</div>
                  <div class="cod-label" style="font-size: smaller;">{{iter.spe ? iter.spe : ' - '}}</div>
                  <div v-if="iter.spi" class="cod-label" style="font-size: smaller;">{{$Jed.firstUpperTranslate('substitute code')}}: {{iter.spi}}</div>
                  <div v-else class="cod-label" style="font-size: smaller;color: white !important;">_</div>
                  <!--icona carrello-->
                  <div v-if="!$Components['GridBox.purchase'].hidden"
                    class="cod-label row" style="font-size: smaller;">
                    <span style=" color: #3c8dbc;" @click.prevent="openPurchasePopup(iter, index, $event)">
                      <i :class="$root.icons.cart" style="font-size: 1.2em;"></i>
                    </span>
                  </div>
                </div>
                <!--mostro solo la descrizione prodotto-->
                <div v-else>
                  <div class="cod-label" style="font-size: smaller;">{{iter.des}}</div>

                  <!--icona carrello-->
                  <div v-if="!$Components['GridBox.purchase'].hidden"
                    class="cod-label row" style="font-size: smaller;">
                    <span style=" color: #3c8dbc;" @click.prevent="openPurchasePopup(iter, index, $event)">
                      <i :class="$root.icons.cart" style="font-size: 1.2em;"></i> 
                    </span>
                  </div>
                </div>
              </div>

              <!--info prodotto-->
                <!--non c'è il flag popup acquisto-->
              <div v-else class="caption"><div class="cod-label" style="font-size: smaller;"><span v-if="showId">{{iter.spi ? iter.spi : iter.sid + " - " }}</span>{{iter.des}}</div></div>
            </a>
          </div>
        </div>
        <div style="position: absolute; top: 38%; left: 48%;" v-if="isLoading" class="sk-cube-grid">
            <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
            <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
        </div>
        <single-modal @API="MerchModal = $event" :title="$Jed.firstUpperTranslate(this.merchModalConfigs.title)" :options="merchModalConfigs">
          <div class="modal-input">
            <img v-if="merchModalConfigs.type=='image'" :src="this.merchModalConfigs.content" style="max-width: 100%;"/>
            <div v-else id="dynTableWCont" style="overflow-y: auto; overflow-x: hidden; max-height: -webkit-fill-available;">
              <dyn-table-wrapper :arrayToTable="this.merchModalConfigs.array" name="merchGrid" ></dyn-table-wrapper>
            </div>
          </div>
        </single-modal>

        <purchasePopup id="merchPurchasePopup" :chooseQty="chooseQty" :purchaseSid="purchaseSid" :purchaseDes="purchaseDes" 
            :purchasePrice="purchasePrice" :popupHeight="popupHeight" :product="product" :arrayToTable="prodInCart" :tableConfigs="{title: 'merchGrid'}">
        </purchasePopup>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { eventBus } from "../../eventbus";
import SingleModal from "../dynamic/modalWrapper/SingleModal.vue"
import DynTableWrapper from "../dynamic/DynTableWrapper.vue";
import PurchasePopup from '../others/PurchasePopup.vue'
import purchasepopup_mixin from "../../mixins/purchasepopup_mixin.js";

var vm;
$(window).resize(function() {
  if (vm != null) {
    vm.setRowHeight();
  }
});

export default {
  name: "Grid",
  components: {SingleModal, DynTableWrapper,PurchasePopup},
  mixins: [purchasepopup_mixin],
  props: {
    activeData: Object
  },
  mounted: function() {
    vm = this;
    if (this.activeData) {
      this.assignData();
    }
    try {
      this.showId = this.$Components["mainForm.navTree"].showId;
    } catch (err){}
  },
  created: function() {
    var vm = this;
    eventBus.$on("detail_changed", () => {
      vm.$root.showOnlyImg = false;
      vm.$root.styleSupportSidebarIcons();
      vm.ready = true;
      vm.setRowHeight();
      vm.init();
    });
    eventBus.$on('document_loaded', function(){
      vm.isLoading = false;
    })

    eventBus.$on("openMerchModal", function(msg, type, content, source, i) {
      vm.merchModalConfigs.title = msg
      vm.merchModalConfigs.type = type
      if(type=='leaves'){
        if(content.length>1){
          $('#merchPurchaseModal').children().css("max-width","70%")
          vm.merchModalConfigs.array = content
          vm.merchModalConfigs.content = ''
          eventBus.$emit("node_clicked");
          vm.MerchModal.open();
        }else if(content.length==1){
          var obj = content[0]
          //il click sull'icona del carrello non deve innescare la chiusura del popup di acquisto
          source.stopPropagation(); //fermo la propagazione dell'evento di click in modo che non si inneschi la chiusura del popup
          $('#merchPurchasePopup').mousedown(function(event){ //il click sull'area che comprende il popup non ne innesca la chiusura
            event.stopPropagation();
          });

          vm.minQuantity = obj.mqt ? obj.mqt : 1;
          var quant = obj.qty && obj.mqt ? (obj.qty >= obj.mqt ? obj.qty : obj.mqt) : obj.qty;
          vm.product = {
            cod: obj.sid,
            qty: quant,
            descr: obj.des,
            unitmis: obj.uni, 
            refObj: obj,
            csy: vm.$root.token.valuta
          };

          var item = vm.$root.shopCartData ? vm.$root.shopCartData.prodotti.find( v => {
            return v['codiceProd'] === obj.sid || (v['codiceProd'] === obj.spi && v['codSost'] === obj.sid)
          }) : null
          if( item != null) {
            obj.qca = item.quantita;              
          }

          if(obj.qca){
            $("#popupquantita2IdmerchGrid").val(obj.qca);
          }else{
            $("#popupquantita2IdmerchGrid").val(vm.product && vm.product.qty ? vm.product.qty : 1);
          }
          $("#popupquantita2IdmerchGrid").attr('min', vm.minQuantity);
          $("#popupquantita2IdmerchGrid").attr('max', vm.maxQuantity);
          vm.manageCounter();
          
          if(vm.chooseQty){
            vm.chooseQty = false
          }else{
            vm.chooseQty = true
            var top;

            console.log('CLIENT: ',source.clientX, source.clientY)
            console.log('THUMB-'+i+': ', $('#thumb-'+i).width(), $('#thumb-'+i).height())

            var lp = source.clientX - $('#sidebar-left').width()
            if(lp>650){
              lp = source.clientX - $('#sidebar-left').width() - $("#merchPurchasePopup").width();
            }
            var tp = source.clientY - $('#thumb-'+i).height() + 50
            if(source.clientY>550){
              tp = source.clientY - $('#thumb-'+i).height() - $("#merchPurchasePopup").height() + 120
            }

            $("#merchPurchasePopup").css('top', tp);
            $("#merchPurchasePopup").css('left', lp);
            $('.popup-arrow').css('display', 'none')
            $('.popup-arrow-border').css('display', 'none')
            
            vm.purchaseDes = obj.spi ? obj.spdes : obj.des;
            vm.purchaseSid = obj.spi ? obj.spi : obj.sid;
            var pp = obj.pri /* Number(obj.uprice.replace('€','')) */
            pp = Number(pp).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            vm.purchasePrice = !vm.$root.token.hidePrices ? pp + " " + vm.$root.token.valuta : null
            vm.popupHeight = vm.purchasePrice != null ? 'height: 220px;' : 'height: 200px;'
          } 
        }
      }else{
        $('#merchPurchaseModal').children().css("max-width","640px")
        vm.merchModalConfigs.array = []
        vm.merchModalConfigs.content = content
        vm.MerchModal.open();
      }
    });

    $(window).mousedown(function(e) { //al rilascio del mouse su una qualunque area della finestra chiudo il popup di acquisto
        vm.closePopups();
    });
  },
  data: function() {
    var vm = this;
    return {
      showId: false,
      iterable: [],
      ready: false,
      products: [],
      classes: [],
      leaves: [],
      isLoading: false,
      merchModalConfigs:{
        content: 'image',
        array: [],
        title: 'image',
        showCancelButton: false,
        showConfirmButton: false,
        closeAfterConfirm: true,
        id: 'merchPurchaseModal'
      },
      chooseQty: false,
      purchaseDes: '',
      purchasePrice: '',
      purchaseSid: '',
      minQuantity: 1,
      maxQuantity: 9999999,
      product: null,
      popupHeight: '',
      prodInCart: []
    };
  },
  watch: {
    activeData: function() {
      this.assignData();
    }
  },
  methods: {
    setRowHeight: function(){
      this.$nextTick(function(){
          var h = window.innerHeight;
          var conth = h - 55;
          var cont = document.getElementById("grid-layout")
          if(cont){
            cont.style.height = conth + "px";
          }
        })
    },
    init: function() {
      this.iterable = this.products;
      this.ready = true;
      this.setRowHeight();
    },
    assignData: function() {
      this.products = this.activeData.children;
      var vm = this;
      
      /*var ancestors = vm.$Configs.nodeInfo*/
      var ancestorsMapping = this.$root.front_end_configs.cartItemInfo
      console.log(ancestorsMapping)

      try {
        this.products = this.products.map(function(obj){
          var r = obj,
            name, prop;
          if(obj.sor){
            //r.sor = Number(obj.sor);
            r.sor = obj.sor; //si può evitare il cast a Number solo se sor è sempre una stringa e se va bene ordinarlo come stringa 
          }

          console.log(vm.activeData.father)
          
          if(ancestorsMapping){
            r.f_fid = vm.activeData.father[ancestorsMapping.ldi] //codice linea
            r.f_sid = vm.activeData.father[ancestorsMapping.mpi] //codice macchina
            r.f_des = vm.activeData.father[ancestorsMapping.mde] //descrizione macchina
          }else{
            r.f_fid = ""
            r.f_sid = vm.activeData.father.sid //codice macchina
            r.f_des = vm.activeData.father.des //descrizione macchina
          }

          /* for(var anc in ancestors){
            var first = ancestors[anc]
            if(vm.activeData.father.typ == anc){
              for(var a in first){
                var second = first[a]
                for(var p in second.properties){
                  name = second.properties[p].name
                  prop = second.properties[p].prop
                  
                  if('any' in first){ //caso Unitec
                    if(a == 'any'){
                      if(prop == 'sid'){
                        r.f_sid = vm.activeData.father[name] //codice macchina 
                      }
                      if(prop == 'des'){
                        r.f_des = vm.activeData.father[name] //descrizione macchina 
                      }
                    }else if(prop == 'sid'){
                      r.f_fid = vm.activeData.father[name] //codice linea 
                    }
                  }else{
                    if(prop == 'sid'){
                      r.f_sid = vm.activeData.father[name] //codice macchina 
                    }
                    if(prop == 'des'){
                      r.f_des = vm.activeData.father[name] //descrizione macchina 
                    }
                  }
                }
              }
            }
          } */

          return r;
        })
      } catch(err){
        console.log(err)
      }

      console.log(this.products)

      this.init();
      this.setClasses();
    },
    setClasses: function(){
      this.classes = [];
      var baseClass;
      if(this.iterable.length <= 4){
        baseClass = "col-xs-6";
      } else if(this.iterable.length <= 9){
        baseClass = "col-xs-6 col-md-4";
      } else {
        baseClass = "col-xs-6 col-md-4 col-lg-3";
      }
      
      for(var i = 0; i < this.iterable.length; i++){
        this.classes.push(baseClass);
      }

      var r,
      exception,
      maxW;

      r = this.iterable.length % 2;
      if(r != 0){
        this.classes[this.iterable.length-1] += " col-xs-offset-3"
      }
      maxW = "825px"
      if(this.iterable.length > 4){
        r = this.iterable.length % 3;
        exception = null; 
        maxW = "1025px"
        if(r != 0){
          if(r == 1){
            exception = this.iterable.length-1;
            this.classes[exception] += " col-md-offset-4"
          } else {
            exception = this.iterable.length-2;
            this.classes[exception] += " col-md-offset-2"
          }
        }
        for(var i = 0; i < this.classes.length; i++){
          if(i != exception){
            this.classes[i] += " col-md-offset-0"
          }
        }
      }
      if(this.iterable.length > 9){
        r = this.iterable.length % 4;
        exception = null; 
        maxW = "1350px"
        if(r != 0){
          if(r == 1){
            exception = this.iterable.length-1;
            this.classes[exception] += " col-lg-offset-4-5"
          } else if(r == 2){
            exception = this.iterable.length-2;
            this.classes[exception] += " col-lg-offset-3"
          } else if(r == 3){
            exception = this.iterable.length-3;
            this.classes[exception] += " col-lg-offset-1-5"
          }
        }
        for(var i = 0; i < this.classes.length; i++){
          if(i != exception){
            this.classes[i] += " col-lg-offset-0"
          }
        }
      }
      this.$nextTick(function(){

         var rc = document.getElementById("row-container")
         rc.style["max-width"] = maxW
      })
     
    },
    itemClicked: function(elem) {
      eventBus.$emit("item_clicked", elem);
    },
    anteprima(iter){
      if(iter.gra && iter.gra.length > 0){
        return this.$root.getGraphic(iter.gra[0].sfn, "thumb" , true)
      } else {
        return ""
      }
    },
    loadDoc(node){
      console.log(node)
      this.isLoading = true;
      this.queryThis(node.sid, node.fid);

      var vm = this;
      eventBus.$emit("closeSidebarDocumenti")
      eventBus.$emit("loadingDocument")
      setTimeout(function(){
        //caricamento diretto del documento nel viewer 
        try{
            var d = node.doc[0];
            var fname =  d.na.split(".");
            d.ext = fname.pop();
            d.filename = fname.join(".");
            if(d.np){
                d.preview = vm.getPage(d.filename, 1, d.np) + "_tn.jpg";
            }
            eventBus.$emit("changeView", "ImgLayout")
            vm.$nextTick(function(){
                vm.$nextTick(function(){
                    vm.reading = d;
                    eventBus.$emit("read_pdf", {d:d, from: 'rec-list-doc'})
                })
            })
        }catch(e){
          console.log(e)
          eventBus.$emit("alert", {type: "warning", message: vm.$Jed.firstUpperTranslate("missing document")});
          vm.isLoading = false;
        }
      }, 100); 
    },
    openImage(node, i, evt){
      $('.thumbnail').css( "box-shadow", "none");
      $('#thumb-'+i).css( "box-shadow", "rgb(60 141 188) 2px 2px 4px");
      var path;
      if(node.gra && node.gra.length > 0){
        path = this.$root.getGraphic(node.gra[0].sfn, "display" , true)
      } else {
        path = ""
      }
      eventBus.$emit('openMerchModal', node.des, 'image', path, evt, i);
    },
    openPurchasePopup(node, i, evt){
      $('.thumbnail').css( "box-shadow", "none");
      $('#thumb-'+i).css( "box-shadow", "rgb(60 141 188) 2px 2px 4px");
      this.queryThis(node.sid, node.fid, null, null, null, null, evt, i, node)
      console.log(node)
    },
    closePopups(){
        this.chooseQty = false
    },
    getFigure4: function(n){
      n = n.toString();
      var figures = n.length;
      var res = "";
      for(var i = 0; i < 4-figures; i++){
          res += "0"
      }
      res += n;
      return res;
    },
    getPage: function(name, npage, ntot){
      return name + "_p" + this.getFigure4(npage) + "-" + this.getFigure4(ntot);
    },
    queryThis: function(id, fid, path, step, focus, nav_promise, src_evt, i, node) {
      var vm = this;
      if(node.iti == 'part'){
        eventBus.$emit('openMerchModal', node.des, 'leaves', [node], src_evt, i);
      }else{
        this.$root
        .microservice({
        role: "catalog",
        cmd: "SearchByFather",
        params: {
            fid: id,
            // aggiunto gfid nelle searchByFather che richiedono info sul padre (meta: true), così posso identificare univocamente il nodo, e non cercare per "sid": fid ottenendo un primo res casuale
            gfid: fid,
            labels: "all",
            leaves: true,
            prod_info: ["att", "not", "gra", "typ", "spi", "doc", "mqt","iti","uni"],
            meta: true,
            meta_prod_info: ["gra", "typ", "def","iti"],
            saleability: true
        }
        })
        .then(
          response => {
              var res = response.body;
              try {
                res = JSON.parse(response.body);
              } catch (err) {}

              this.children = [];
              if (res.children) {
                for (var i = 0; i < res.children.length; i++) {
                    var obj = res.children[i];
                    if(!obj.lin){
                        obj.opened = false;
                        obj.triggered = false;
                        obj.execonopen = null;
                        obj.nav_promise = null;

                        this.children.push(obj);
                    }
                }
                
                if (path != null && step != null) {
                    var extract;
                    try {
                      extract = path[step + 1].id;
                    } catch (err) {
                      console.log(err)
                    }
                    if (extract == null || extract == "") {
                      this.changeRoute(res, focus, {"path": path, "step": step, "nav_promise": nav_promise});
                      //quando sto eseguendo una navigazione diretta, commit active item solo all'ultimo step della procedura
                    
                    } else {
                      this.$nextTick(function() {
                          this.direct(path, step, focus, nav_promise);
                      });
                      this.loading = false;
                    }
                    
                } else {
                    this.changeRoute(res); 
                }
              } else {
                this.loading = false;
              }

              if (this.children.length == 0) {
                this.am_i_leaf = true;
              }

              this.leaves = []
              var emitevent = false
              if(res.leaves){
                for (var i = 0; i < res.leaves.length; i++) {
                  var obj = res.leaves[i];
                  if(obj.typ == 'Articoli di stampa' || this.activeData.father.pvi){
                    this.leaves.push(obj);
                  }
                  if(this.activeData.father.pvi){
                    emitevent = true
                  }
                }
              }
              if(emitevent && this.leaves.length>0)eventBus.$emit('openMerchModal', res.answer.des, 'leaves', this.leaves, src_evt, i);
          },
          err => {
              this.loading = false;
              console.log('Grid - queryThis - SearchByFather')
              console.log(err)
              //vedi gestione errore in main.js > microservice
          }
        )
        .catch(err => {
            console.log(err);
            /* var msg = err && err.body && err.body.error ? err.body.error : err
            eventBus.$emit('alert', {
              message: "Application caught an error <br> <h5>Details: " + "catalog.SearchByFather - " + msg +'</h5>',
              type: "error",
              action: ''
            }) */
        });
      }
    },
    changeRoute: function(res, focus, nextParams) {
      var vm = this;
      this.$store.commit("setActive", {
          father: res.answer,
          children: res.children,
          leaves: res.leaves
      });
    }
  }
};
</script>

<style>
.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: space-around;
  justify-content: space-around;
  overflow-y: auto;
  max-height: -webkit-fill-available;

  /* IE:
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 580px;*/
}

.flex-item {
  padding: 10px;
  padding-bottom: 20px;
  width: 150px;
}

div.sweet-content .btn-default {
  background-color: #f4f4f4 !important;
  color: #444 !important;
  border-color: #ddd !important;
}
</style>
<style scoped>
.cod-label {
  line-height: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  text-align: center;
}

.container {
  position: relative;
  width: 100%;
  height: 100%;
}

.image {
  opacity: 1;
  display: block;
  /*height: 100%;*/
  width: 100%;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
  cursor: pointer;
}

.container:hover .image {
  opacity: 0.3;
}

.container:hover .middle {
  opacity: 1;
}

.text {
  background-color: rgba(250, 250, 250, 0.9);
  color: black;
  font-size: 15px;
  padding: 10px 15px;
}

.embed-responsive.bg-cover {
    background-position: left 100% 100%;
    -webkit-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -o-background-size: 100% 100%;
    background-size: 100% 100%;
    
    background-position: center;
    background-size: cover;
}

@media (min-width: 1200px) {
  .col-lg-offset-1-5 {
      margin-left: 12.48333333%;
  }

  .col-lg-offset-4-5 {
      margin-left: 37.48333333%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sub-views/Grid.vue?1c86ff1f